import { useEffect } from 'react';
export const META_PIXEL_ID = '1673698393761692';
const SNIPPET_ID = 'meta-pixel-snippet';

/**
 * Injects the official Meta Pixel base code verbatim into <head> so that the
 * Meta Pixel Helper extension detects it exactly as it would in plain HTML.
 */
const PIXEL_SNIPPET = `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${META_PIXEL_ID}');
fbq('track', 'PageView');`;
export function MetaPixel() {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    if (document.getElementById(SNIPPET_ID)) return;
    const script = document.createElement('script');
    script.id = SNIPPET_ID;
    script.type = 'text/javascript';
    script.text = PIXEL_SNIPPET;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" alt="" src="https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1" />`;
    document.head.appendChild(noscript);
  }, []);
  return null;
}